import CertificateDetails from "@/components/CertificateDetails";
import { useLocation } from "wouter";
import { certificates } from '../../../db';
import ErrorBoundary from "@/components/ErrorBoundary";

export type CertificateType = {
  id: number;
  title: string;
  issuingOrganization: string;
  issueDate: string;
  expiryDate?: string | null;
  pdfPath?: string | null;
  skills?: string[] | null;
  logoPath?: string | null;
  link?: string | null;
};

export const certificatesDataMap: Record<string, CertificateType> = certificates.reduce((acc, certificate) => {
  const urlKey = certificate.id.toString();
  acc[urlKey] = certificate;
  return acc;
}, {} as Record<string, CertificateType>);

export default function CertificatePage() {
  const [location] = useLocation();
  const certificateId = location.split('/certificate/')[1]?.split('?')[0];
  
  if (!certificateId) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Zertifikat nicht gefunden</h1>
          <p className="text-muted-foreground">Die angeforderte Zertifikat-ID ist ungültig.</p>
        </div>
      </div>
    );
  }

  const certificate = certificatesDataMap[certificateId];
  
  if (!certificate) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Zertifikat nicht gefunden</h1>
          <p className="text-muted-foreground">
            Das Zertifikat mit der ID "{certificateId}" existiert nicht.
          </p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="min-h-screen">
        <div className="container mx-auto py-8 px-4">
          <CertificateDetails certificate={certificate} />
        </div>
      </div>
    </ErrorBoundary>
  );
}
